import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthManagerService } from '../auth-manager/auth-manager.service';
import { RegistrationProgressService } from '../registration-progress/registration-progress.service';
import { UserService } from '../user/user.service';
import { User } from 'src/app/interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(
    private authManager: AuthManagerService,
    private router: Router,
    private registrationProgressService: RegistrationProgressService,
    private userService: UserService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authManager.isAuthenticated) {
      this.userService.getMe().subscribe((userResponse: User) => {
        this.redirectUserOrNavigateToDashboard(userResponse);
      });
    }

    return true;
  }

  private redirectUserOrNavigateToDashboard(user: User) {
    const progressData =
      this.registrationProgressService.getRegistrationProgressData(user);
    if (
      !progressData.isFullNameRegistrationCompleted ||
      !progressData.isMembershipSelectionCompleted ||
      !progressData.isPetChipNumberRegistrationCompleted ||
      !progressData.isWelcomePackSelectCompleted
    ) {
      // The registration is incomplete -> navigate user to stage1
      this.router.navigate(['/account/owner-details']);
    } else if (this.router.url !== '/'){
      this.router.navigate(['/dashboard']);
    }
  }
}
